export const RateCallStatus = Object.freeze({
	HasData: 'hasData',
	NoData: 'noData',
	Error: 'error',
});
